<script lang="ts">
  import SectionBoard from "../../molecules/SectionBoard.svelte";
  import { onMount } from "svelte";
  import OrderSection from "../OrderSection.svelte";
  import DetailSection from "./DetailSection.svelte";
  import BlueButton from "../BlueButton.svelte";
  import Pagination from "../../molecules/Pagination.svelte";
  import { MasterMunicipalityService } from "../../services/municipality.service";
  import { ApiService } from "../../services/api.service";
  import { writable } from "svelte/store";
  import FormWithLabel from "../../molecules/FormWithLabel.svelte";

  const name = "municipality";
  const label = "市区町村";
  const service = new MasterMunicipalityService(name);
  let loading = service.store.loading;
  let model = service.store.model;
  let models = service.store.models;
  let currentModels = service.store.currentModels;
  let page = service.store.page;
  let size = service.store.size;
  let prefecture = service.prefecture;
  const prefectures = writable([]);
  let unselected = { id: null };
  $: disabled = $prefecture === unselected.id;

  onMount(async () => {
    const ps = await ApiService.getMasterList("prefectures");
    prefectures.set(ps);
    unselected = ps.find((r) => r.label === "未選択");
    service.initPrefecture(unselected);
  });
</script>

<div class="flex">
  <SectionBoard>
    <h2 class="font-semibold mb-4">
      {label}
    </h2>

    <FormWithLabel
      label="都道府県"
      input={service.handlePrefecture}
      value={$prefecture}
      inputType="select"
      options={$prefectures}
    />

    <BlueButton click={service.addMunicipality} klass="mt-4" rounded {disabled}>
      追加
    </BlueButton>

    {#if $models.length !== 0}
      <OrderSection
        models={$currentModels}
        handleDndConsider={service.handleDndConsider}
        handleDndFinalize={service.handleDndFinalize}
        handleModel={service.handleModel}
        selected={$model}
      />

      <Pagination
        page={$page}
        result={$models.length}
        next={service.handleNext}
        previous={service.handlePrevious}
        klass="mt-4"
      />
    {/if}
  </SectionBoard>

  {#if $model.id}
    <SectionBoard klass="ml-6">
      <DetailSection
        model={$model}
        handleLabel={service.handleLabel}
        handleOrder={service.handleOrder}
        handleDisabled={service.handleDisabled}
        save={service.saveMunicipality}
        remove={service.remove}
        loading={$loading}
        max={$size}
      />
    </SectionBoard>
  {/if}
</div>
